import { useSnackbarStore } from '@/stores/use-snackbar-store'

export const useSnackbar = () => useSnackbarStore(state => state.addSnackbar)
